import React from "react";
import FiltersContext from "../../restaurantsMap/FiltersContext";
import FiltersForm from "./FiltersForm";
import getAvailableOptions from "../../restaurantsMap/helpers/getAvailableOptions";
import getCurrentMapPosition from "../../restaurantsMap/helpers/getCurrentMapPosition";
import getSelectedRestaurants from "../../restaurantsMap/helpers/getSelectedRestaurants";
import getCoords from "../../restaurantsMap/helpers/getCoords";
const Filters = () => {
  return (
    <div className="filters">
      <FiltersContext.Consumer>
        {({
          data,
          setCurrentFilters,
          setAvailableOptions,
          currentMapPosition,
          setCurrentMapPosition,
          availableOptions,
          initMapPosition,
          setSelectedRestaurants
        }) => (
          <FiltersForm
            dataForm={currentFilters => {
              setCurrentFilters(currentFilters);

              setAvailableOptions(
                getAvailableOptions(currentFilters, data, availableOptions)
              );

              setCurrentMapPosition(
                getCurrentMapPosition(
                  currentFilters,
                  currentMapPosition,
                  data,
                  initMapPosition
                )
              );

              setSelectedRestaurants(
                getSelectedRestaurants(
                  getCoords(data.countries, currentFilters),
                  currentFilters
                )
              );
            }}
          />
        )}
      </FiltersContext.Consumer>
    </div>
  );
};

export default Filters;
